import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import NVDBaseMetrics from '../../../shared/vulns/Drawer/NVDBaseMetrics';

/**
 * VulnerabilityIssueDetailsNVDBaseMetrics displays the NVD base metrics of the vulnerability
 * currently being viewed.
 */
const VulnerabilityIssueDetailsNVDBaseMetrics: VoidFunctionComponent = () => {
  const metrics = useSelector(IssuesV2Store.selectors.getMetrics);

  if (!metrics.length) {
    return null;
  }

  return (
    <NVDBaseMetrics
      metrics={metrics}
    />
  );
};

export default VulnerabilityIssueDetailsNVDBaseMetrics;
